<div class="p-20 fx-row fx-wrap align-items-center justify-content-center text-center">
    <div class="fx-flex-100 align-items-center justify-content-center text-center">
        <span class="title mb-10 text-center">{{(mode == 'create' ? 'ORGANIZATION.CREATE_CAMPAIGN' :
            'ORGANIZATION.EDIT_CAMPAIGN'
            ) | translate}}</span>
    </div>
    <span class="text mt-20">{{(mode == 'create' ? 'ORGANIZATION.CREATE_CAMPAIGN_HINT' :
        'ORGANIZATION.EDIT_CAMPAIGN_HINT'
        ) | translate:campaignToCreate}}</span>
    <div class="fx-flex-100 fx-row fx-wrap align-items-center justify-content-center mt-20">
        <app-input [placeholder]="('CAMPAIGN.NAME' | translate) + '...'" type="text" class="mb-10 fx-flex-100"
            [(value)]="campaignToCreate.name" [error]="errors['name']" [bottomWrapper]="true"></app-input>

        <app-select initial="none" label="{{'CAMPAIGN.TYPE' | translate}}" [options]="types" [multiple]="false"
            class="mb-10 fx-flex-100" [(value)]="campaignToCreate.type" [emitOnInit]="false"
            (change)="onTypeChange($event)">
        </app-select>
        <div class="mb-10 fx-flex-100 text-left">
            <span class="text" *ngIf="campaignToCreate.type">{{'CAMPAIGN.TYPE_'+campaignToCreate.type+'_HINT' |
                translate}}</span>
        </div>
        <ng-container [ngSwitch]="campaignToCreate.type">
            <div class="fx-flex-100" *ngSwitchCase="'CASE'">
                <app-case-select label="{{'ENTITIES.CASE' | translate}}" [multiple]="false" [search]="true"
                    (change)="onCaseChange($event)" [(value)]="caseTarget" [emitOnInit]="false"
                    [error]="errors['targets']" [bottomWrapper]="true"></app-case-select>
            </div>
            <div class="fx-flex-100" *ngSwitchCase="'COUNTRY'">
                <app-territory-select label="{{'ENTITIES.TERRITORY' | translate}}" [multiple]="false" [search]="true"
                    (change)="onTerritoryChange($event)" [(value)]="territoryTarget" [emitOnInit]="false"
                    [error]="errors['targets']" [bottomWrapper]="true">
                </app-territory-select>
            </div>
            <div class="mb-10 fx-flex-100 text-left align-items-center justify-content-start fx-row"
                *ngSwitchCase="'OPERATORS'">
                <mat-icon class="main mr-5" fontSet="material-icons-outlined">chevron_right</mat-icon>
                <span class="text">{{'CAMPAIGN.TARGETTED_ROLE_USERS' |
                    translate:userTargets}}</span>
            </div>
            <div class="mb-10 fx-flex-100 text-left align-items-center justify-content-start fx-row"
                *ngSwitchCase="'CASE_OPERATORS'">
                <mat-icon class="main mr-5" fontSet="material-icons-outlined">chevron_right</mat-icon>
                <span class="text">{{'CAMPAIGN.TARGETTED_ROLE_USERS' |
                    translate:userTargets}}</span>
            </div>
            <div class="mb-10 fx-flex-100 text-left align-items-center justify-content-start fx-row"
                *ngSwitchCase="'COUNTRY_OPERATORS'">
                <mat-icon class="main mr-5" fontSet="material-icons-outlined">chevron_right</mat-icon>
                <span class="text">{{'CAMPAIGN.TARGETTED_ROLE_USERS' |
                    translate:userTargets}}</span>
            </div>
            <div class="mb-10 fx-flex-100" *ngSwitchCase="'INDIVIDUALS'">
                <app-select label="{{'ENTITIES.USERS' | translate}}" [options]="userOptions" [multiple]="true"
                    (change)="onUsersChange($event)" [emitOnInit]="false" [error]="errors['targets']"
                    [bottomWrapper]="true"></app-select>
                <div class="fx-row align-items-center justify-content-start">
                    <mat-icon class="main mr-5" fontSet="material-icons-outlined">chevron_right</mat-icon>
                    <span class="text">{{'CAMPAIGN.TARGETTED_ROLE_USERS' |
                        translate:userTargets}}</span>
                </div>
            </div>
        </ng-container>
        <div class="mv-10 fx-flex-100 text-left">
            <app-select initial="none" label="{{'CAMPAIGN.SCHEDULE' | translate}}" [options]="schedules"
                [multiple]="false" [emitOnInit]="false" [(value)]="campaignToCreate.schedule"
                (change)="onScheduleChange($event)" [error]="errors['schedule']" [bottomWrapper]="true">
            </app-select>
            <span class="text"
                *ngIf="campaignToCreate.schedule">{{('CAMPAIGN.SCHEDULE_TEXT_'+campaignToCreate.schedule.toUpperCase())
                |
                translate}}</span>
        </div>
        <div class="mv-10 fx-flex-100 text-left"
            *ngIf="campaignToCreate.type && campaignToCreate.entity && !['CASE','COUNTRY'].includes(campaignToCreate.type.toString())">
            <span class="text">{{'CAMPAIGN.TARGET_SPECIFIC_ENTITY' | translate}}</span>
            <div class="mb-10 fx-flex-100 text-left align-items-center justify-content-start fx-row">
                <div class="mv-10 fx-flex-50 text-left pr-10">
                    <app-select initial="none" label="{{'CAMPAIGN.ENTITY' | translate}}" [options]="entities"
                        [multiple]="false" [emitOnInit]="false" [(value)]="campaignToCreate.entity.type"
                        (change)="onEntityTypeChange($event)">
                    </app-select>
                </div>
                <div class="mv-10 fx-flex-50 text-left pl-10">
                    <app-trademark-family-select label="{{'ENTITIES.TRADEMARK_FAMILIES' | translate}}"
                        [multiple]="false" [search]="true" (change)="onEntityRefChange($event)" [emitOnInit]="false"
                        *ngIf="campaignToCreate.entity.type == 'trademarkFamily'"></app-trademark-family-select>

                    <app-trademark-select label="{{'ENTITIES.TRADEMARKS' | translate}}" [multiple]="false"
                        [search]="true" (change)="onEntityRefChange($event)" [emitOnInit]="false"
                        *ngIf="campaignToCreate.entity.type == 'trademark'">
                    </app-trademark-select>
                </div>
            </div>

        </div>


    </div>
    <mat-divider class="fx-flex-100 mv-20"></mat-divider>
    <div class="fx-row align-items-center justify-content-center fx-flex-100">
        <button class="button fx-flex mr-10" (click)="onCancel()">{{'ACTIONS.CANCEL' | translate}}</button>
        <button class="main-button fx-flex ml-10" (click)="mode == 'create' ? onCreate() : onEdit()"
            [class.disabled]="isDisabled()" [disabled]="isDisabled()">{{(mode == 'create' ? 'ACTIONS.CREATE' :
            'ACTIONS.EDIT'
            )
            | translate}}</button>
    </div>
</div>